import React from 'react';
import SectionHeader from '../components/SectionHeader';

export default function ProjectLeadership() {
  return (
    <div className="page-wrapper">
      <div className="container">
        <SectionHeader title='Scott Mason — "Full Stack" Project Leader' />

        <div className="clearfix info-block">
          <img
            alt="eCommerce"
            src="/images/projects/ecommerce.jpg"
            className="float-img-right"
            style={{ height: 214, width: 355 }}
            onError={e => { e.target.style.display = 'none'; }}
          />
          <p>Many people can manage a project.</p>
          <p>In today's environment of ever increasing rapid change, <u>simple management</u> of a project is not enough.</p>
          <p>Projects must be tracked closely and lead from chaos to successful delivery.</p>
          <br />
          <p>Scott has a certification in and uses Servant Leadership principles, including Listening, Empathy, Healing, Awareness, Persuasion, Conceptualization, and Foresight to work with people. Scott has done the following:</p>
          <ul>
            <li>Managed many integrations from ERP systems to Cloud Snowflake and Databricks Machine Learning and Data Science projects</li>
            <li>He has managed SharePoint migrations from SharePoint on-premises to SharePoint Online (Office 365) at Marriott International</li>
            <li>Managed migration of SharePoint version 2010 to 2013 at Hyundai</li>
            <li>Managed automated workflow in SharePoint with custom screens for the procurement process at Hyundai</li>
            <li>Security: Designed and implemented reports to customers under California Consumer Privacy Act (CCPA)</li>
            <li>Security: Managed new objects with the Company's GRC (Governance, Risk &amp; Compliance) solution using the NIST Cybersecurity Framework</li>
            <li>Security: HIPAA Certified, PCI, PHI, SOX, Privacy data subject access rights (DSAR), FedRAMP cloud compliant systems</li>
            <li>Managed SAP projects: $72MM and $49MM projects</li>
            <li>Managed both small and large teams</li>
            <li>He has managed the full development life-cycle (SDLC) for Enterprise eCommerce web sites, including an $11 Billion eCommerce site</li>
            <li>Presented to CEOs, Executive Vice Presidents, VPs, Directors, and others</li>
            <li>He has extensive experience in preparing and delivering presentations to customers, C-Level executives, and explaining complex technical issues to business people</li>
          </ul>
        </div>

        <div className="info-block">
          <p>A strong quantitative educational foundation encompassing Mathematics, Statistics, Econometrics, Financial Engineering, Operations Research, Computer Science, and Physics with a Bachelor of Arts degree from the University of Oregon. Bachelor's degree in Business Administration from the University of Oregon.</p>
        </div>

        <div className="clearfix info-block">
          <img
            alt="Azure Analytics"
            src="/images/projects/azure-analytics.png"
            className="float-img-right"
            style={{ height: 214, width: 355 }}
            onError={e => { e.target.style.display = 'none'; }}
          />
          <ul>
            <li>Scott's experience above demonstrates a self-starter approach with the ability to multi-task</li>
            <li>
              Experience as a Project Leader with:
              <ul>
                <li>Nike</li>
                <li>Oakley</li>
                <li>Adidas</li>
                <li>Hyundai</li>
                <li>Lam Research</li>
                <li>and other Fortune 500 companies</li>
              </ul>
              gives him a unique perspective in working for some of the best run innovators in the world
            </li>
            <li>He has direct experience in Fortune 500 companies <strong><u>ERP</u></strong> Sales and Distribution, Financial systems, and Data Science programs</li>
            <li>Scott is an excellent writer and has excellent documentation skills</li>
            <li>Scott has strong written and oral communication skills, with an ability to convey a vision of the organization's strategic future to all stakeholders.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
